import { render } from "./ChatRoomHeader.vue?vue&type=template&id=5d84351d"
import script from "./ChatRoomHeader.vue?vue&type=script&lang=js"
export * from "./ChatRoomHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/partials/ChatRoomHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d84351d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d84351d', __exports__)) {
    api.reload('5d84351d', __exports__)
  }
  
  module.hot.accept("./ChatRoomHeader.vue?vue&type=template&id=5d84351d", () => {
    api.rerender('5d84351d', render)
  })

}


export default __exports__